export const SN_SEARCH = 'SEARCH'
export const SET_RESULTS = `${SN_SEARCH}/SET_RESULTS`
export const SET_LOADING = `${SN_SEARCH}/SET_LOADING`
